import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LoginButton = memo(({ mobile, onNavigate }) => {
  const { t } = useTranslation();
  const className = mobile
    ? "header--new__btn--mobile header--new__btn--login btn-n btn-n--gray"
    : "header--new__btn--desktop header--new__btn--login btn-n btn-n--gray";

  return (
    <Link
      className={className}
      to="/admin"
      onClick={onNavigate}
    >
      <span className="btn-n__text">{t("nav.login")}</span>
    </Link>
  );
});

export default LoginButton;
